import { BACKEND_BASE_URL } from '@/config.ts'
import api from '@/repositories/apiInterceptor.ts'

export const createProject = async (name: string, tz?: string): Promise<Project> => {
  const { data } = await api.post(`${BACKEND_BASE_URL}/api/v1/projects`, { name, timezone: tz })
  return data
}

export const acceptInvitation = async (invitationCode: string): Promise<Project> => {
  const { data } = await api.post(`${BACKEND_BASE_URL}/api/v1/projects/invite/accept`, {
    invitationCode,
  })
  return data
}
